import React, { createContext, useContext } from 'react';

// ✅ 完全移除無用的 useState/useEffect/console.log
// 固定淺色模式，value 物件在模組層級建立，永不重建
const THEME_VALUE = {
  isDark: false,
  theme: 'light',
  toggleTheme: () => {},
};

const ThemeContext = createContext(THEME_VALUE);

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => (
  <ThemeContext.Provider value={THEME_VALUE}>
    {children}
  </ThemeContext.Provider>
);